/**
 * RoutineOwnershipSection — routine picker for the Role Contract editor.
 *
 * Replaces the old UUID textarea with a real multi-select picker that:
 *  - Shows routines by title with domain pill
 *  - Filters to active routines by default (toggle for archived)
 *  - Renders selected entries as removable chips
 *  - Highlights archived/missing entries with a warning indicator
 *  - Provides an empty-state link to /roros/artifacts/routines
 */

import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { t } from '@/lib/i18n';
import { RoutinePicker } from '@/components/roros/RoutinePicker';
import type { EditorState } from '../roleContractEditorState';

interface Props {
  state: EditorState;
  setState: React.Dispatch<React.SetStateAction<EditorState>>;
}

export function RoutineOwnershipSection({ state, setState }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('Routine Ownership')}</CardTitle>
      </CardHeader>
      <CardContent>
        <RoutinePicker
          selected={state.routineOwnership}
          onChange={(entries) =>
            setState((s) => ({ ...s, routineOwnership: entries }))
          }
        />
      </CardContent>
    </Card>
  );
}
